import { useMemo } from 'react';
import {
  STORE_PROPS,
  useGetPaymentService,
  usePaymentsStore
} from '../../store';

export const useInitialDepositAmount = (): string | number => {
  const recommendedDepositAmount = usePaymentsStore(
    STORE_PROPS.RECOMMENDED_DEPOSIT_AMOUNT
  );
  // @ts-expect-error should be solved inside useGetPaymentService
  const { lastDepositAmount = '' } = useGetPaymentService();

  const initialAmount = useMemo(
    () => recommendedDepositAmount ?? lastDepositAmount,
    [lastDepositAmount, recommendedDepositAmount]
  );

  return initialAmount;
};
